import classNames from "classnames";
import "./Navbar.scss";

type NavbarProps = {
	children: React.ReactNode;
	className?: string;
};

const Navbar = ({ children, className }: NavbarProps) => {
	return <nav className={classNames("nav__bar", className)}>{children}</nav>;
};

export default Navbar;
